exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3_IIx3qL7PLWV0{padding:0;text-align:center;background-color:#172b4d}.y713MCtKnRL7Xv{color:#dfe1e6;line-height:32px;margin:0}.y713MCtKnRL7Xv ._3DtarySw4qn2vr,.y713MCtKnRL7Xv a{color:#97a0af;margin-left:8px}", ""]);

// exports
exports.locals = {
	"banner": "_3_IIx3qL7PLWV0",
	"text": "y713MCtKnRL7Xv",
	"linkSeparator": "_3DtarySw4qn2vr"
};